<template>
  <div class="header">
    <div class="inner">
      <div class="logo" @click="toHome">
        <img src="//cdnw2.acmcoder.com/release/exam/2.0.1/images/wlogo.png" />
      </div>
      <div class="fr" :class="{ active: menuActive }">
        <i class="iconfont iconmulu-lujing" @click="menuActiveHander()"></i>
      </div>
    </div>
    <div class="menu" v-if="menuActive">
      <el-menu
        :default-active="activeTab"
        :router="true"
        :show-timeout="100"
        active-text-color="#29bdb9"
        background-color="rgba(0,0,0,0.6)"
        class="el-menu-demo"
        mode="horizontal"
        @select="menuSelectHandler"
        ref="menu"
        text-color="#fff"
      >
        <el-menu-item index="1" route="/home">首页</el-menu-item>
        <el-menu-item index="2" route="/product/exam"
          >产品（在线考试）</el-menu-item
        >
        <el-menu-item index="2" route="/product/interview"
          >产品（在线面试）</el-menu-item
        >
        <el-menu-item index="3" route="/scene">应用场景</el-menu-item>
        <!-- <el-menu-item index="4" route="/customer">客户案例</el-menu-item>
        <el-menu-item index="5" route="/tariff/exam"
          >价格（在线考试）</el-menu-item
        >
        <el-menu-item index="6" route="/tariff/interview"
          >价格（在线面试）</el-menu-item
        > -->
        <el-menu-item index="7" route="/link/about">关于赛码</el-menu-item>
      </el-menu>
    </div>
    <div class="lang-drop">
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          {{ text }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(v, index) in ['CN', 'EN']"
            :key="index"
            :command="v"
            >{{ v }}</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import product from './product'
import loginB from './login/to-b'

export default {
  name: 'haader',
  components: {
    product,
    loginB,
  },
  data() {
    return {
      activeTab: '1',
      menuActive: false,
      text: 'CN',
    }
  },
  mounted() {},
  methods: {
    handleCommand(v) {
      this.text = v
      if (v === 'EN') {
        location.href = location.href.replace('www', 'www-en')
      } else {
        location.href = location.href.replace('www-en', 'www')
      }
    },
    toHome() {
      this.$router.push({ path: '/home' })
      document.title =
        '在线考试产品 - 【赛码网】在线考试系统、在线面试系统-易用稳定专业'
    },
    menuActiveHander() {
      this.menuActive = !this.menuActive
    },
    menuSelectHandler() {
      this.menuActive = false
    },
  },
}
</script>

<style lang="scss" scoped>
.header {
  background: #000000 !important;
  height: 60px;
  position: fixed;
  top: 0px;
  width: 100%;
  z-index: 999;
  font-size: 18px;

  .lang-drop {
    margin-top: 10px;
    margin-left: 20px;
  }
  .inner {
    margin: 0px auto;
    height: 60px;
    padding: 0px 10px 0px 0px;
    .logo {
      img {
        height: 45px;
      }

      float: left;
      margin: 6px 30px 0px 10px;
    }
    .fr {
      color: #fff;
      float: right;
      height: 60px;
      line-height: 60px;
      transition: transform 0.3s;
      &.active {
        transform: rotate(-90deg);
      }
      .iconfont {
        font-size: 30px;
      }
    }
  }
  .el-menu-item {
    width: 100%;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/mobile-header.vue